export default __webpack_public_path__ + "static/media/original.0c004e4f.png";